/**
 * Created by zhaohaixi on 2018/9/12.
 */
import Cookie from 'js/lib/cookie'
import TYPES from '../types'

export const lenovoDataInitState = { // 全局变量，不可修改
  // 预热和升级时候用，目前为logo旁边的小图标，和右侧栏用
  coundown: {},
  userInfo: {},
  accountInfo: {},
  LenovoData: {},
  language: 'zh', // 语言
  customize: { // 自定义设置,水印等相关
    customService: 0,
    helpDocument: 0,
    helpDocumentUrl: '',
    helpGuide: 0,
    switchLanguage: true,
    disableDownloadClient: true,
    customize_setting: '{}',
  },
  userRole: [], // 用户角色
}

export const LenovoDataGetters = {
  // accountId: (state) => state.lenovoData.userInfo.account_id,
  // uId: (state) => state.lenovoData.userInfo.uid,
  // userInfo: (state) => state.lenovoData.userInfo,
  // S: (state) => state.lenovoData.userInfo.S,
  // accountInfo: (state) => state.lenovoData.accountInfo,
  // accountConfig: (state) => state.lenovoData.customize,
  // userRole: (state) => state.lenovoData.userRole,
  accountId: (state) => state.lenovoData.userInfo.account_id,
  uId: (state) => state.lenovoData.userInfo.uid,
  S: () => Cookie.get('S'),
  userInfo: (state) => state.lenovoData.LenovoData && state.lenovoData.LenovoData.userinfo,
  accountInfo: (state) => state.lenovoData.LenovoData && state.lenovoData.LenovoData.accountinfo,
  accountConfig: (state) => state.lenovoData.customize,
  entRole: (state) => state.lenovoData.userInfo.entRole,
  custominfo: (state) => {
    if (state.lenovoData.LenovoData) {
      const { custominfo } = state.lenovoData.LenovoData
      const custominfoObj = {}
      if (custominfo) {
        custominfo.forEach((item) => {
          custominfoObj[item.name] = item.value
        })
      }
      return custominfoObj
    }
    return {}
  },
  managerAbilities: (state) => state.lenovoData.LenovoData.ability
    && state.lenovoData.LenovoData.ability.filter((code) => code !== 100 && code !== 118),
  hasAll: (state) => state.lenovoData.LenovoData.ability
  && state.lenovoData.LenovoData.ability.some((code) => code === 100),
}

export const lenovoDataMutations = {
  [TYPES.GET_LENOVO_LANGUAGE](state, data) {
    state.lenovoData.language = data
  },
  [TYPES.SWITCH_LENOVO_LANGUAGE](state, data) {
    state.lenovoData.language = data
    window.localStorage.setItem('language', data)
    Cookie.set('language', data, { path: '/', domain: window.SERVER_NAME })
  },
  [TYPES.GET_USER_INFO](state, data) {
    state.lenovoData.userInfo = data
  },
  [TYPES.GET_SESSION](state, data) {
    state.lenovoData.session = data
  },
  [TYPES.GET_LENOVO_ACCOUNT_INFO](state, data) {
    state.lenovoData.accountInfo = data
  },
  [TYPES.GET_LENOVO_CUSTOMIZE_INFO](state, data) {
    state.lenovoData.customize = data
  },
  [TYPES.GET_CNAME](state, data) {
    state.lenovoData.cname = data
  },
  [TYPES.LENOVO_DATA](state, data) {
    // promise-all中存在设置state.lenovoData.LenovoData的行为，这里将设置好的值，搬移到这里
    state.lenovoData.LenovoData = { ...data, ...state.lenovoData.LenovoData }
    state.lenovoData.LenovoData.accountinfo = JSON.parse(data.accountinfo || '{}')
    state.lenovoData.LenovoData.userinfo = JSON.parse(data.userinfo || '{}')
    state.lenovoData.userInfo.S = Cookie.get('S')
  },
  [TYPES.GET_USER_ROLE](state, data) {
    /**
         * 1 super_admin 网盘管理员
         * 2 ent_admin 企业管理员
         * 3 doc_admin 文档管理员
         * 4 org_admin 组织架构管理员
         * 5 audit_admin 审计管理员
         * 6 policy_admin 策略管理员
         * 7 team_admin 团队成员管理员
         */
    const userRole = []
    data.forEach((item) => {
      if (item.key === 'doc_admin' && item.type === 3) { // 管控全部团队的文档管理员新加个标识
        userRole.push(...[item.key, 'all_team_doc_admin'])
      } else {
        userRole.push(item.key)
      }
    })
    state.lenovoData.userRole = userRole
  },
  // [TYPES.GET_COUNT_DOWN](state, data) {
  //   state.lenovoData.countdown = data
  // },
}
